// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fI63","col":"styles_col__1bfRI"};